import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import portalApi, { getPortalToken, setPortalToken, clearPortalToken } from './portalApi';

const PortalAuthContext = createContext(null);

export const PortalAuthProvider = ({ children }) => {
  const [token, setToken] = useState(getPortalToken());
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const stored = getPortalToken();
    if (!stored) {
      setMe(null);
      setLoading(false);
      return;
    }
    try {
      const r = await portalApi.get('/me');
      setMe(r.data);
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [token, refresh]);

  const setSession = useCallback((newToken) => {
    setPortalToken(newToken);
    setToken(newToken);
  }, []);

  const signOut = useCallback(async () => {
    try { await portalApi.post('/auth/logout'); } catch { /* ignore */ }
    clearPortalToken();
    setToken(null);
    setMe(null);
  }, []);

  const switchClient = useCallback(async (clientId) => {
    await portalApi.post('/auth/switch-client', { clientId });
    await refresh();
  }, [refresh]);

  return (
    <PortalAuthContext.Provider value={{ token, me, loading, setSession, signOut, refresh, switchClient }}>
      {children}
    </PortalAuthContext.Provider>
  );
};

export const usePortalAuth = () => {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be used inside PortalAuthProvider');
  return ctx;
};
